import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import IngredientDetailPage from "./pages/IngredientDetailPage";
import ComparePage from "./pages/ComparePage";
import HomePage from "./pages/HomePage";
import MainLayout from "./MainLayout";
import SelectOtherProducts from "./components/SelectOtherProducts";
import { CompareProvider } from "./CompareContext";
import MainPage from "./pages/MainPage";
import ScanPage from "./pages/ScanPage";
import PersonalizePage from "./pages/PersonalizePage";
import VitaminsDetailPage from "./pages/VitaminsDetailPage";
import ProductPage from "./pages/ProductPage";
import SupportPage from "./pages/SupportPage";
import LegalPage from "./pages/LegalPage";
import TrialExitSurveyPage from "./pages/TrialExitSurveyPage";

const App = () => {
  return (
    <CompareProvider>
      <Router>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/trial-exit-survey" element={<TrialExitSurveyPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/product/:barcodeOrId" element={<ProductPage />} />
            <Route path="/ingredient/:ingredient" element={<IngredientDetailPage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/select-products" element={<SelectOtherProducts />} />
            <Route path="/food" element={<MainPage />} />
            <Route path="/vitamin" element={<VitaminsDetailPage />} />
            <Route path="/scan" element={<ScanPage />} />
            <Route path="/personalize" element={<PersonalizePage />} />
            <Route path="/" element={<HomePage />} />
          </Route>
        </Routes>
      </Router>
    </CompareProvider>
  );
};

export default App;
